<template>
  <div>
    <div class="row mb-4">
      <div class="col-4">
        <b-form-select
          @change="changeProfile"
          v-model="selected"
          :options="profiles"
        ></b-form-select>
      </div>
    </div>
    <div class="row" v-if="loading">
      <div class="col-12">
        <div class="text-center text-primary my-2">
          <b-spinner type="grow" class="align-middle"></b-spinner>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-4" v-for="(item, i) in permissions" :key="i">
        <item-profile
          :busy="loading"
          :items="permissions[i]"
          :fields="[
            {
              key: 'name',
              label: $t('menu.settings.users.labels.menuModal', {
                position: `${i}`,
              }),
            },
            { key: 'value', label: $t('menu.settings.users.labels.enable') },
          ]"
          :p-key="i"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import itemProfile from '@/components/organisms/settings/profiles/item-profile';
import eventBus from '../../../../eventBus';

export default {
  name: 'ProfilePermissions',
  components: {
    itemProfile,
  },
  props: ['user'],
  data: () => ({
    selected: null,
    userAuth: null,
    loading: false,
  }),
  computed: {
    ...mapState('profiles', ['permissions', 'profileId']),
    ...mapFields('profiles', ['profiles']),
  },
  methods: {
    ...mapActions('profiles', [
      'getProfiles',
      'getProfile',
      'setStateProfile',
      'profileAttributes',
    ]),
    changeProfile() {
      this.loading = true;
      this.getProfile({
        token: this.userAuth.token,
        profileId: this.selected,
        email: this.user.email,
        changeProfile: true,
      }).then((data) => {
        data.lang = this.$i18n.locale;
        this.setStateProfile(data);
        this.loading = false;
      });
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  mounted() {
    this.getProfile({
      token: this.userAuth.token,
      profileId: this.user.profileId,
      email: this.user.email,
    }).then(async (data) => {
      await this.getProfiles({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
      });

      data.lang = this.$i18n.locale;
      this.setStateProfile(data);
      const profileExists = this.profiles.find((obj) => obj.value === data._id);

      if (profileExists) {
        this.selected = data._id;
      } else {
        this.profiles.push({ value: data._id, text: 'Personalizado' });
        this.selected = data._id;
      }
    });

    eventBus.$on('profile-attributes', () => {
      this.profileAttributes({
        userId: this.user._id,
        profileId: this.selected,
        token: this.userAuth.token,
      });
    });
  },
  beforeDestroy() {
    eventBus.$off('profile-attributes');
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/molecules/modal-permissions/actions-permissions/index.vue